export const CURRENCY = 'USD';
export const TRIAL_TIER_NAME = 'Pro';
